/* eslint-disable no-console */
import {
    SAVE_POSTS,
    SAVE_TAGS,
    SAVE_CATEGORY,
} from './_types';

import BlogService from '@/taskflex/blog/services/BlogService';

export default {
    loadCategory({ commit, getters }, options) {
        return new Promise((resolve, reject) => {
            const categoryById = getters.categoryById(options.id);
            if (categoryById) {
                resolve(categoryById);
                return;
            }

            BlogService.query(`categories/${options.id}`, {}, (response) => {
                const { data } = response;

                commit(SAVE_CATEGORY, data, options);

                resolve(data);
            }, response => reject(response));
        });
    },

    loadCategoryBySlug({ commit, getters }, options) {
        return new Promise((resolve, reject) => {
            const categoryBySlug = getters.categoryBySlug(options.slug);

            if (categoryBySlug) {
                resolve(categoryBySlug);
                return;
            }

            BlogService.query('categories', { slug: options.slug }, (response) => {
                const { data } = response;

                commit(SAVE_CATEGORY, data[0], options);

                resolve(data[0]);
            }, response => reject(response));
        });
    },

    fetchPostsForCategory({ commit, getters }, options) {
        return new Promise((resolve, reject) => {
            const posts = getters.postsByCategoryId(options.id);

            const category = getters.categoryById(options.id);

            if (posts.length >= category.count) { // TODO: add pagination
                resolve(posts);
                return;
            }

            BlogService.query('posts', { categories: options.id }, (response) => {
                const { data } = response;

                commit(SAVE_POSTS, data, options);

                resolve(data);
            }, response => reject(response));
        });
    },

    loadTags({ commit }, options) {
        return new Promise((resolve, reject) => {
            BlogService.query('tags', options, (response) => {
                const { data } = response;

                if (!data.length) {
                    reject(response);
                    return;
                }

                commit(SAVE_TAGS, data, options);

                resolve(data);
            }, response => reject(response));
        });
    },

    loadTag({ commit, getters }, options) {
        return new Promise((resolve, reject) => {
            const tagById = getters.tagById(options.id);
            if (tagById) {
                resolve(tagById);
                return;
            }

            BlogService.query('tags', { include: options.tag }, (response) => {
                const { data } = response;

                if (!data.length) {
                    reject(response);
                    return;
                }

                commit(SAVE_TAGS, data, options);

                resolve(data);
            }, response => reject(response));
        });
    },

    loadTagBySlug({ commit, getters }, options) {
        return new Promise((resolve, reject) => {
            const tagBySlug = getters.tagBySlug(options.slug);
            if (tagBySlug) {
                resolve(tagBySlug);
                return;
            }

            BlogService.query('tags', { slug: options.slug }, (response) => {
                const { data } = response;

                if (!data.length) {
                    reject(response);
                    return;
                }

                commit(SAVE_TAGS, data[0], options);

                resolve(data[0]);
            }, response => reject(response));
        });
    },

    fetchPostsForTag({ commit, getters }, options) {
        return new Promise((resolve, reject) => {
            const postsByTagId = getters.postsByTagId(options.id);

            if (postsByTagId.length) {
                resolve(postsByTagId);
                return;
            }

            BlogService.query('posts', { tags: options.id }, (response) => {
                const { data } = response;

                if (!data.length) {
                    reject(response);
                    return;
                }

                commit(SAVE_POSTS, data, options);

                resolve(data);
            }, response => reject(response));
        });
    },

    fetchPost({ commit, getters }, options) {
        return new Promise((resolve, reject) => {
            const post = getters.postBySlug(options.slug);

            if (post) {
                resolve(post);
                return;
            }

            BlogService.query('posts', { slug: options.slug }, (response) => {
                const { data } = response;

                if (!data || !data.length) {
                    reject(response);
                    return;
                }

                commit(SAVE_POSTS, data, options);

                resolve(data[0]);
            }, response => reject(response));
        });
    },
};



// WEBPACK FOOTER //
// ./src/taskflex/blog/store/_actions.js